import React, { useState, useEffect } from "react";
import { Card, CardHeader, CardBody, Table, Button } from "reactstrap";
import local from "../../../localization/strings";
import { emailReportRunNow, emailReportsList } from "../../../api/reports";
import { CurrentUserHasRole, CurrentUserId } from "../../../api/auth";
import { roles } from "../../../config";
import { toast } from "react-toastify";

const DisplayReportList = ({ triggerModify }) => {
	const [data, setData] = useState([]);

	useEffect(() => {
		const LoadData = async () => {
			var result = await emailReportsList();

			setData(result);
		};

		LoadData();
	}, []);

	const onRunNow = async (id) => {
		setData((x) => {
			const cloned = JSON.parse(JSON.stringify(x));
			const found = cloned.find((x) => x.id === id);
			if (found) {
				found.runNow = true;
			}
			return cloned;
		});
		await emailReportRunNow(id);
		toast.success(local.TF_RunNowScheduled);
	};

	return (
		<Card>
			<CardHeader>
				<h5>{local.TF_Scheduled_Emails}</h5>
			</CardHeader>
			<CardBody className="pt-0">
				<Table className="table-hover table-sm mb-0 fs--1 rounded-soft table-striped">
					<thead className="bg-200 text-900">
						<tr>
							<th>{local.TF_Report_Name}</th>
							<th>{local.TS_Type}</th>
							<th>{local.TS_Recipients}</th>
							<th>{local.TF_Send_email_every}</th>
							<th />
						</tr>
					</thead>
					<tbody>
						{data &&
							data.map((item, index) => (
								<tr key={index}>
									<td className="align-middle">{item.reportName}</td>
									<th className="align-middle">{item.reportType}</th>
									<td className="align-middle">{item.emailRecipients}</td>
									<td className="align-middle">
										{item.frequency} {item.time.substring(0, 5)}
									</td>
									<td className="text-right">
										{(CurrentUserHasRole(roles.DepartmentAdmin) || item.addedBy === CurrentUserId()) && (
											<>
												<Button color="info" className="btn-xs" onClick={() => triggerModify(item)}>
													{local.TS_Modify}
												</Button>
												<Button color="info" className="btn-xs mt-1" onClick={() => onRunNow(item.id)} disabled={item.runNow}>
													{local.TF_RunNow}
												</Button>
											</>
										)}
									</td>
								</tr>
							))}
					</tbody>
				</Table>
			</CardBody>
		</Card>
	);
};

export default DisplayReportList;
